/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  if ($("#refreshing_stocks_please_wait").length > 0) {
    const refresh_method = () => location.reload();

    return setTimeout(refresh_method, 2000);
  }
});